<script>
import PaginationNav from '../components/PaginationNav'
import PaginationFilter from '../components/PaginationFilter'

export default {
  components: { PaginationFilter, PaginationNav },
  methods: {
    setPage(index) {
      this.pagination.page = index
      window.scrollTo(0, 0)
    },
    // paginate(entries) {
    //   const start = this.pagination.page * this.pagination.perPage
    //   return [...entries].splice(start, this.pagination.perPage)
    // },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

</style>



// WEBPACK FOOTER //
// src/views/mixins/Pagination.vue